import { endPoints, API_ROOT } from "../../../appSettings";
import { adalApiFetch } from "../../../authProvider";
import {
  BoundTo,
  ProductType,
  UsageLimitType,
  getKeyByDisplayName,
  getKeyByValue,
} from "../../../constant";

export const GET_LICENSES = "GET_LICENSES";
export const ADD_LICENSE = "ADD_LICENSE";
export const UPDATE_LICENSE = "UPDATE_LICENSE";
export const DELETE_LICENSE = "DELETE_LICENSE";
export const GET_FEATURES = "GET_FEATURES";
export const ADD_FEATURE = "ADD_FEATURE";
export const UPDATE_FEATURE = "UPDATE_FEATURE";

export function getLicenses(
  page = 1,
  limit = 10,
  sortBy = 1,
  orderBy = 0,
  search = "",
  family = -1,
  type = -1,
  searchBy = 0,
  operation = 0
) {
  const url = `${API_ROOT}${endPoints.entitlement}/product/list?page=${page}&limit=${limit}&sortBy=${sortBy}&orderBy=${orderBy}&searchText=${search}&unitFamilyId=${family}&unitTypeId=${type}&searchBy=${searchBy}&operation=${operation}`;
  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  };

  return async (dispatch) => {
    const response = await adalApiFetch(fetch, url, options, dispatch);
    const json = await response.json();

    if (!response.ok) {
      return Promise.reject(json);
    }

    return dispatch({
      type: GET_LICENSES,
      isSuccess: true,
      payload: json,
    });
  };
}

export function addLicenseAndMap(license) {
  return (dispatch) => {
    return dispatch(addLicense(license))
      .then((json) =>
        dispatch({
          type: ADD_LICENSE,
          isSuccess: true,
          mapResponse: json,
        })
      )
      .catch((error) => {
        return dispatch({
          type: ADD_LICENSE,
          isSuccess: false,
          payload: error,
        });
      });
  };
}

export function updateLicenseAndMapping(productId, license) {
  return (dispatch) => {
    return dispatch(updateLicense(productId, license))
      .then((json) =>
        dispatch({
          type: UPDATE_LICENSE,
          isSuccess: true,
          mapResponse: json,
        })
      )
      .catch((error) => {
        return dispatch({
          type: UPDATE_LICENSE,
          isSuccess: false,
          payload: error,
        });
      });
  };
}

export function deleteLicense(productId) {
  const url = `${API_ROOT}${endPoints.entitlement}/product/${productId}`;
  const options = {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  };

  return async (dispatch) => {
    const response = await adalApiFetch(fetch, url, options, dispatch);
    const json = await response.json();

    if (!response.ok) {
      return dispatch({
        type: DELETE_LICENSE,
        isSuccess: false,
        payload: json,
      });
    }

    return dispatch({
      type: DELETE_LICENSE,
      isSuccess: true,
      payload: json,
    });
  };
}

function addLicense(license) {
  const url = `${API_ROOT}${endPoints.entitlement}/product`;
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: parseLicense(license),
  };

  return async (dispatch) => {
    const response = await adalApiFetch(fetch, url, options, dispatch);
    const json = await response.json();

    if (!response.ok) {
      return Promise.reject(json);
    }

    return dispatch({
      type: ADD_LICENSE,
      isSuccess: true,
      payload: json,
    });
  };
}

function updateLicense(productId, license) {
  const url = `${API_ROOT}${endPoints.entitlement}/product/${productId}`;
  const options = {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: parseLicense(license),
  };

  return async (dispatch) => {
    const response = await adalApiFetch(fetch, url, options, dispatch);
    const json = await response.json();

    if (!response.ok) {
      return Promise.reject(json);
    }

    return dispatch({
      type: UPDATE_LICENSE,
      isSuccess: true,
      payload: json,
    });
  };
}

function parseLicense(license) {
  const units = [];
  license.units.map((unit) =>
    units.push({
      family: unit.family,
      type: unit.type,
      version_start: unit.versionStart,
      version_end: unit.versionEnd,
    })
  );

  return JSON.stringify({
    use_for_product_name: license.units[0].family,
    product_number: license.productNumber,
    package_id: license.packageId,
    package_name: license.packageName,
    feature_ids: license.featureIds,
    duration: license.duration,
    number_of_unlock: license.numberOfUnlock,
    requires_online: Boolean(Number(license.requiresOnline)),
    requires_fw_vers: license.requiredFirmwareVersions,
    bound_to: getKeyByDisplayName(BoundTo, license.boundTo),
    product_type: getKeyByDisplayName(ProductType, license.productType),
    usage_limit_type: getKeyByValue(
      UsageLimitType,
      Number(license.usageLimitType)
    ),
    usage_limit: license.usageLimit,
    requires_login: Boolean(Number(license.requiresLogin)),
    signature_size: license.signatureSize,
    use_for_product_sap_no: [],
    units: units,
    is_valid: true,
  });
}

export const AddFeature = (field) => {
  return (dispatch) =>
    adalApiFetch(
      fetch,
      `${API_ROOT}${endPoints.feature}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(field),
      },
      dispatch
    )
      .then((response) => {
        if (!response.ok) {
          return response.json().then((json) => {
            return dispatch({
              type: ADD_FEATURE,
              isSuccess: false,
              payload: json,
            });
          });
        }

        return response.json().then((json) => {
          return dispatch({
            type: ADD_FEATURE,
            isSuccess: true,
            payload: json,
          });
        });
      })
      .catch((error) => {
        console.error(error);
      });
};

export const UpdateFeature = (field) => {
  return (dispatch) =>
    adalApiFetch(
      fetch,
      `${API_ROOT}${endPoints.feature}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(field),
      },
      dispatch
    )
      .then((response) => {
        if (!response.ok) {
          return response.json().then((json) => {
            return dispatch({
              type: UPDATE_FEATURE,
              isSuccess: false,
              payload: json,
            });
          });
        }

        return response.json().then((json) => {
          return dispatch({
            type: UPDATE_FEATURE,
            isSuccess: true,
            payload: json,
          });
        });
      })
      .catch((error) => {
        console.error(error);
      });
};

export const GetFeatures = () => {
  return (dispatch) =>
    adalApiFetch(
      fetch,
      `${API_ROOT}${endPoints.feature}/list`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      },
      dispatch
    )
      .then((response) => response.json())
      .then((json) => {
        return dispatch({
          type: GET_FEATURES,
          payload: json,
        });
      });
};

export const GetActivityLogs = (
  startDate,
  endDate,
  page = 1,
  limit = 10,
  sort = 0,
  order = 1,
  search = "",
  activity = 0,
  searchBy = 0,
  operation = 0
) => {
  return (dispatch) => {
    return adalApiFetch(
      fetch,
      `${API_ROOT}${endPoints.license}${endPoints.activityLogs}?page=${page}&limit=${limit}&startDate=${startDate}&endDate=${endDate}&sortby=${sort}&orderby=${order}&searchtext=${search}&activity=${activity}&searchby=${searchBy}&operation=${operation}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      },
      dispatch
    ).then((response) => response.json());
  };
};
